import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GlobalSettings } from '../models/global-settings-dto';

@Injectable({ providedIn: 'root' })
export class GlobalSettingsApiService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.apiUrl + '/global-settings';

  public getGlobalSettings(): Observable<GlobalSettings> {
    return this.httpClient.get<GlobalSettings>(this.baseUrl);
  }
}
